import { render, staticRenderFns } from "./FileEditor.vue?vue&type=template&id=5e417133&scoped=true&"
import script from "./FileEditor.vue?vue&type=script&lang=ts&"
export * from "./FileEditor.vue?vue&type=script&lang=ts&"
import style0 from "./FileEditor.vue?vue&type=style&index=0&id=5e417133&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e417133",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VDivider,VIcon,VProgressCircular,VTextField,VTreeview})
